import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { useSpc } from '../context/SpcContext';
import { AchIcon, catColor } from './Achievements';
import { motion, AnimatePresence } from 'framer-motion';

export default function Celebration() {
  const { celebration, closeCelebration } = useSpc();

  useEffect(() => {
    if (!celebration) return;
    const colors = ['#e1e20a', '#f2f34d', '#ffffff'];
    const fire = (ratio, opts) => confetti({ particleCount: Math.floor(180 * ratio), spread: 70, origin: { y: 0.5 }, colors, zIndex: 200, ...opts });
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.9 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });
    const b1 = setTimeout(() => confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.6 }, colors, zIndex: 200 }), 250);
    const b2 = setTimeout(() => confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.6 }, colors, zIndex: 200 }), 400);
    const auto = setTimeout(() => closeCelebration(), 6000);
    return () => { clearTimeout(b1); clearTimeout(b2); clearTimeout(auto); };
  }, [celebration, closeCelebration]);

  return (
    <AnimatePresence>
      {celebration && (
        <motion.div className="celebrate-backdrop" onClick={closeCelebration}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.div className="celebrate-card" onClick={(e) => e.stopPropagation()}
            initial={{ scale: 0.7, opacity: 0, y: 30 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}>
            <div className="celebrate-eyebrow">Achievement Unlocked</div>
            <motion.div className="celebrate-icon" style={{ '--cat-color': catColor(celebration.category) }} initial={{ scale: 0, rotate: -30 }} animate={{ scale: 1, rotate: 0 }} transition={{ delay: 0.15, type: 'spring', stiffness: 300, damping: 14 }}>
              <AchIcon a={celebration} size={44} />
            </motion.div>
            <h2>{celebration.title}</h2>
            <p>{celebration.description}</p>
            {celebration.points > 0 && <div className="celebrate-points">+{celebration.points} SPC Points</div>}
            <button className="btn" onClick={closeCelebration}>Let's go 👊</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
